/**
  * Archivo: response-visita-validar.model.tsx
  *   Autor: Jahaziel Jeuh Baltazar Isidoro <jahaziel.baltazar@finalsoft.com.mx>
  *   Fecha: Septiembre 21, 2023.
  */
export default class responseVisitaValidar {
  public idVisita:number =  0;
  public facturada: boolean = false;
  public facturasNota: responseVisitaValidarFacturasNota[] = [];
}
class responseVisitaValidarFacturasNota {
  public idFacturaNota: number = 0;
}
